module.exports = __webpack_public_path__ + "static/media/clock-icon.a45d6aff.svg";